<div class="sidebar-skeleton">
  @for (i of [].constructor(10); track $index) {
    <div class="menu-item">
      <ui-skeleton-loading
        p-width="24"
        p-height="24"
        >
      </ui-skeleton-loading>
      <ui-skeleton-loading
        p-width="140"
        p-height="23"
        >
      </ui-skeleton-loading>
    </div>
  }
</div>
